














































































































import { Component, Mixins } from "vue-property-decorator";
import RequestPromises from "@/mixins/requestPromises";
import {
  INotificationCategory,
  INotificationHook
} from "@/models/notifications";
import { DataModules } from "@/store/modules/data";
import eventsMap from "@/components/app/global/timelineComponent/events";

@Component
export default class AutomationTriggers extends Mixins(RequestPromises) {
  public $refs!: {
    filter: HTMLFormElement;
  };

  public filter = "";
  public isLoading = true;
  public isReloading = false;
  public requestError = false;
  public maxHooksToShow = 4;
  public categories: INotificationCategory[] = [];
  public hooks: INotificationHook[] = [];

  public async created() {
    await this.loadData();
    this.autofocusFilter();
  }

  public async loadData() {
    try {
      await this.getCategories();
    } catch (error) {
      this.$store.dispatch("api/handleError", error);
      this.requestError = true;
    }
    this.isLoading = false;
    this.isReloading = false;
  }

  public reloadData() {
    this.isReloading = true;
    this.loadData();
  }

  public highlight = (needle, haystack) =>
    haystack.replace(
      new RegExp(needle, "gi"),
      str => `<span class="has-text-info">${str}</span>`
    );

  public get canViewTrigger() {
    return this.$userCan("get_notification_template");
  }

  public autofocusFilter() {
    this.$nextTick(() => {
      this.$refs.filter.focus();
    });
  }

  public get filteredHooks() {
    return this.$_.filter(this.hooks, hook => {
      return hook.name.toLowerCase().includes(this.filter.toLowerCase());
    });
  }

  public async getCategories() {
    this.categories = await this.$store.dispatch(
      `data/${DataModules.NOTIFICATIONS_CATEGORIES}/list`,
      {
        vm: this,
        storeData: false,
        params: {
          limit: 0,
          order: "name",
          with: "hooks",
          "filter[hooks.notifiable]": 1
        }
      }
    );

    const hooks: INotificationHook[] = [];
    this.$_.forEach(this.categories, category => {
      category.hooks = this.$_.sortBy(
        this.$_.filter(category.hooks, hook => hook.notifiable),
        "name"
      );
      category.hooks = this.$_.map(category.hooks, hook => ({
        ...hook,
        name: (eventsMap?.[hook.code]?.name || hook.name) as string
      }));

      this.$_.forEach(this.$_.cloneDeep(category.hooks), hook => {
        const categoryCloned = this.$_.cloneDeep(category);
        delete categoryCloned.hooks;
        hooks.push({
          ...hook,
          name: (eventsMap?.[hook.code]?.name || hook.name) as string,
          category: categoryCloned
        });
      });
    });

    this.hooks = this.$_.sortBy(hooks, "name");
  }
}
